import React from 'react'
import Button from '../../global/Button'
import bannerImageMallCenter from '../../../assets/img/banner-world-mall-week/image-banner-mall-center.png'
import Translation from '../../global/Translation'

const BannerWorldMallWeek = ({ userSalesOrg, className }) => {
    const backgroundImageStyle = {
        backgroundImage: `url(${bannerImageMallCenter})`,
        backgroundSize: 'cover',
        backgroundPosition: '50% 57%',
        backgroundRepeat: 'no-repeat'
    }

    const getRedirectUrl = org => {
        switch (org) {
            case 2005:
            case 1100:
            case 1037:
                return 'https://forms.cosentino.com/the-mall-day-360-iberia/'
            case 2009:
                return 'https://forms.cosentino.com/the-mall-day-360-fr/'
            case 2004:
                return 'https://forms.cosentino.com/the-mall-day-360-it-2/'
            case 2008:
                // Este código aparece en FR - BE y NL - BE.
                return 'https://forms.cosentino.com/the-mall-day-fr-be/'
            case 2000:
                return 'https://forms.cosentino.com/the-mall-day-360-nl/'
            case 2014:
            case 2052:
            case 2047: // Incluido en Austria
            case 2049: // Incluido en Austria
                return 'https://forms.cosentino.com/the-mall-week-aus/'
            case 2001:
                return 'https://forms.cosentino.com/the-mall-week-de/'
            case 2015:
                return 'https://forms.cosentino.com/the-mall-day-360-ie/'
            case 2039:
                return 'https://forms.cosentino.com/the-mall-day-360-fi/'
            case 2011:
            case 2037: // También cubre Puerto Rico
                return 'https://forms.cosentino.com/the-mall-day-360-usa/'
            case 2002:
                return 'https://forms.cosentino.com/the-mall-day-360-uk/'
            case 2007:
                return 'https://forms.cosentino.com/the-mall-day-360-se/'
            case 2016:
                return 'https://forms.cosentino.com/the-mall-day-360-no/'
            case 2038:
                return 'https://forms.cosentino.com/the-mall-day-360-dk/'
            case 2042:
                return 'https://forms.cosentino.com/the-mall-day-360-pl/'
            case 2010:
                return 'https://forms.cosentino.com/the-mall-week-schweiz/'
            case 2050:
                return 'https://forms.cosentino.com/the-mall-week-czech-republic/'
            case 2032:
                // Este código cubre tanto Canadá EN como Canadá FR.
                return 'https://forms.cosentino.com/the-mall-day-360-north-en-ca/'
            case 2031:
                return 'https://forms.cosentino.com/the-mall-day-360-au/'
            case 2040:
                return 'https://forms.cosentino.com/the-mall-week-nz/'
            case 2017:
                return 'https://forms.cosentino.com/the-mall-day-360-sg/'
            case 2018:
                return 'https://forms.cosentino.com/the-mall-day-360-tr/'
            case 2035:
                return 'https://forms.cosentino.com/the-mall-day-360-uae/'
            case 2034:
                return 'https://forms.cosentino.com/the-mall-day-360-japon/'
            case 2021:
                return 'https://forms.cosentino.com/the-mall-day-360-isr/'
            case 2041:
                return 'https://forms.cosentino.com/the-mall-day-360-afr-c/'
            case 2026:
            case 2027:
                return 'https://forms.cosentino.com/the-mall-day-360-mx-2/'
            default:
                // Por defecto USA
                return 'https://forms.cosentino.com/the-mall-day-360-usa/'
        }
    }

    const redirectUrl = getRedirectUrl(parseInt(userSalesOrg))

    return (
        <div className={"banner-world-mall-week-container container " + className} style={backgroundImageStyle}>
            <div className="sub-container">
                {/* Texts */}
                <div className="text-content">
                    <div className="column-1">
                        <h3>
                            <Translation id="world_mall_week_may_2025" defaultMessage="WORLD MALL WEEK MAY 2025" />
                        </h3>
                        <p>
                            <Translation id="promo_active_until_may_26" defaultMessage="Promo will be active until the 26th of may at 13:00" />
                        </p>
                    </div>
                    <div className="column-2">
                        {/* Text 2 */}
                        <div className="column-2-main-text">
                            <div>
                                <h4>10%</h4>
                            </div>
                            <div>
                                <p>
                                    <Translation id="discount_container_truck" defaultMessage="discount for container or full truck" />
                                </p>
                                <p>
                                    <Translation id="only_promoted_material" defaultMessage="(only promoted material)" />
                                </p>
                            </div>
                        </div>

                        <div className="column-2-second-text">
                            <p>
                                <Translation
                                    id="offer_limited_to_stock"
                                    defaultMessage="Offer limited to units available on stock / Orders will be processed on a first-como, first-served basis"
                                />
                            </p>
                        </div>
                    </div>
                </div>

                {/* Button */}
                <div className="button-content">
                    <a href={redirectUrl} target="_blank" rel="noopener noreferrer">
                        <Button className="world-mall-cta">
                            <Translation id="reserve_now" defaultMessage="Reserve Now" />
                        </Button>
                    </a>
                </div>
            </div>
        </div>
    )
}

export default BannerWorldMallWeek
